import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Box, Chip } from '@mui/material';
import { blue, red } from '@mui/material/colors';
import { string2RGB } from 'core/utils/cssStyles';
import { extname } from 'core/utils/pathUtils';
import { isEmpty } from 'lodash';
import { useMemo, type FC } from 'react';
import type { OrderFile } from 'models/order/orderFile';

interface OrderDocumentIconProps {
  file: OrderFile;
}

const typeColors: Record<string, string> = {
  pdf: red[800],
  doc: blue[900],
  docx: blue[900],
};

const OrderFileIcon: FC<OrderDocumentIconProps> = ({ file }) => {
  const ext = useMemo(() => {
    const extWithoutDot = extname(file.name).replace('.', '');

    return isEmpty(extWithoutDot) ? undefined : extWithoutDot;
  }, [file]);

  const extColor = useMemo(() => {
    const escapedExt = ext ?? 'NO_EXT';

    return typeColors[escapedExt] ?? string2RGB(escapedExt);
  }, [ext]);

  return (
    <Box textAlign={'center'} position={'relative'}>
      <InsertDriveFileOutlinedIcon sx={{ fontSize: 56, color: 'text.secondary' }} />
      <Chip
        sx={{
          backgroundColor: extColor,
          color: (theme) => theme.palette.getContrastText(extColor),
          position: 'absolute',
          left: '50%',
          bottom: 0,
          textTransform: 'uppercase',
        }}
        label={ext}
        size='small'
      />
    </Box>
  );
};

export default OrderFileIcon;
